import { createTheme, Theme } from '@mui/material/styles';
import { PaletteMode } from '@mui/material';

// Define color gradients for both modes
export const getColorGradients = (mode: PaletteMode) => ({
  max: mode === 'dark' ? "#2D5538" : "#62BF7B", // Darker green for dark mode
  mid: mode === 'dark' ? "#5C5231" : "#FDE883", // Darker yellow for dark mode
  min: mode === 'dark' ? "#5C2F31" : "#F9696D", // Darker red for dark mode
});

export const getTheme = (mode: PaletteMode): Theme => createTheme({
  palette: {
    mode,
    primary: {
      main: mode === 'dark' ? '#62BF7B' : '#2E7D32',
    },
    secondary: {
      main: '#dc004e',
    },
    background: {
      // A near-black, faintly green-tinted ground in dark mode (rather than flat MUI gray), so panels read as
      // part of one calm surface instead of floating gray boxes.
      default: mode === 'dark' ? '#0a0d0b' : '#f6f7f5',
      paper: mode === 'dark' ? '#12160f' : '#ffffff',
    },
  },
  shape: {
    borderRadius: 8,
  },
  components: {
    MuiAppBar: {
      styleOverrides: {
        root: {
          backgroundColor: mode === 'dark' ? 'rgba(0, 0, 0, 0.5)' : 'rgba(255, 255, 255, 0.8)',
          backdropFilter: 'blur(8px)',
          color: mode === 'dark' ? '#fff' : '#000',
          boxShadow: 'none',
          borderBottom: `1px solid ${mode === 'dark' ? 'rgba(255, 255, 255, 0.12)' : 'rgba(0, 0, 0, 0.12)'}`,
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          // Kill MUI's dark-mode elevation overlay (it lightens nested Papers to flat gray); a visible border
          // reads as a "card" the way the mockup's panels do.
          backgroundImage: 'none',
          border: `1px solid ${mode === 'dark' ? 'rgba(255, 255, 255, 0.08)' : 'rgba(0, 0, 0, 0.08)'}`,
        },
        elevation1: {
          boxShadow: 'none',
        },
      },
    },
  },
  typography: {
    fontFamily: [
      '-apple-system',
      'BlinkMacSystemFont',
      '"Segoe UI"',
      'Roboto',
      '"Helvetica Neue"',
      'Arial',
      'sans-serif',
    ].join(','),
  },
});

export default getTheme('dark'); 